import Cookies from 'js-cookie';

export interface PersistedConsentData {
  consent: string;
}

// Cookie specs
const CONSENT_COOKIE_EXPIRES_DAYS = 365;
const CONSENT_COOKIE_KEY = 'contact-consent';

const decodeCookieValue = (
  cookieValue: string
): PersistedConsentData | undefined => {
  if (cookieValue === '') return;
  return JSON.parse(atob(cookieValue));
};

const encodeCookieValue = (data: PersistedConsentData): string =>
  btoa(JSON.stringify(data));

const flushAccess = (key: string) => {
  Cookies.remove(key);
};

export const getConsent = (): PersistedConsentData | undefined => {
  const data = Cookies.get(CONSENT_COOKIE_KEY);
  if (!data) return;
  try {
    return decodeCookieValue(data);
  } catch (e) {
    flushAccess(CONSENT_COOKIE_KEY);
  }
};

export const persistConsent = (data: PersistedConsentData) => {
  flushAccess(CONSENT_COOKIE_KEY);
  try {
    Cookies.set(CONSENT_COOKIE_KEY, encodeCookieValue(data), {
      expires: CONSENT_COOKIE_EXPIRES_DAYS,
    });
  } catch (e) {
    // do nothing
  }
};
